<template>
  <div
    class="ims-page"
    :style="`padding-top:${paddingTop}px; padding-bottom:${paddingBottom}px`"
    v-if="canShow"
  >
    <section ref="header" id="page-header">
      <header v-if="slotExists('header')">
        <div
          class="brand-bar"
          :style="`background-color:${$store.state.brand.color || '#FFF'}`"
        />
        <slot name="header" />
      </header>
    </section>
    <slot />
    <section ref="footer" id="page-footer">
      <footer v-if="slotExists('footer')">
        <slot name="footer" />
      </footer>
    </section>
  </div>
  <div class="ims-page" v-else-if="requireLogin && !$User.loggedIn">
    <header v-if="slotExists('header')">
      <div
        class="brand-bar"
        :style="`background-color:${$store.state.brand.color || '#FFF'}`"
      />
      <ims-toolbar>Login Required</ims-toolbar>
    </header>
    <div class="p-4 text-center">
      <p>You must have an account to access this page</p>
      <ims-button
        @click="$store.dispatch('user/login')"
        type="solid"
        color="primary"
        size="lg"
        class="btn-block my-3"
        >Sign up / Login</ims-button
      >
      <div class="text-center p-2 text-sm">
        or
        <router-link to="/">go to start page</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import tick from '../../modules/tick/tick';
export default {
  data() {
    return {
      paddingTop: 0,
      paddingBottom: 0,
      canShow: true
    };
  },
  props: {
    requireLogin: {
      type: Boolean,
      deafult() {
        return false;
      }
    }
  },
  watch: {
    '$store.state.user.loggedIn': {
      handler(loggedIn) {
        if (loggedIn && this.requireLogin) {
          this.canShow = true;
        } else if (!loggedIn && this.requireLogin) {
          this.canShow = false;
        } else {
          this.canShow = true;
        }
      },
      immediate: true
    }
  },
  methods: {
    update() {
      this.setPadding();
    },
    elementHeight(selector) {
      return (document.querySelector(selector) || {}).offsetHeight || 0;
    },
    setPadding() {
      this.paddingTop = this.elementHeight('#page-header header');
      this.paddingBottom = this.elementHeight('#page-footer footer');
    },
    slotExists(name) {
      if (name) {
        return this.$slots.hasOwnProperty(name);
      } else {
        return this.$slots.hasOwnProperty('default');
      }
    }
  },
  updated() {
    this.update();
  },
  async mounted() {
    this.update();
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';
@import '../../scss/vendors/bootstrap-utils';
.ims-page {
  #page-header header {
    z-index: $zindex-fixed;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    box-shadow: $box-shadow-1;
  }
  .brand-bar {
    height: 6px;
  }
  #page-footer footer {
    z-index: $zindex-fixed;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: $box-shadow-1up;
  }
  @include media-breakpoint-up(md) {
    margin-left: $size-sidemenu-width;
    #page-header header,
    #page-footer footer {
      left: $size-sidemenu-width !important;
    }
    .main-menu-button {
      display: none;
    }
  }
}
</style>
